import { render, staticRenderFns } from "./recipeAudit.vue?vue&type=template&id=95f1f60e&scoped=true&"
import script from "./recipeAudit.vue?vue&type=script&lang=js&"
export * from "./recipeAudit.vue?vue&type=script&lang=js&"
import style0 from "./recipeAudit.vue?vue&type=style&index=0&id=95f1f60e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f1f60e",
  null
  
)

export default component.exports